import styled from 'styled-components';

export const TimeLogTable = styled.div`
  div[role='table'] {
    .fa-trash:hover {
      color: red;
    }
  }

  .total-text {
    font-weight: 700;
    margin-top: 1%;
    margin-left: 1%;
  }
`;
